import template from './checks.html';
import controller from './checks.controller';

let checksComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default checksComponent;
